import axios from 'axios';
import qs from 'qs';
import ElementUI from 'element-ui';
import router from '../router';
import globalProcessing from '@/components/common/globalProcessing';
const service = axios.create({
  // baseURL: '/gapi', // 废弃，现使用window.$intercept配置文件
  // timeout: 30000,
  withCredentials: true,
});
// post-----JSON入参
export function jsonPost(url, data = {}) {
  return service.post(url, data);
}
// post-----formData入参
export function formPost(url, data = {}) {
  let datas;
  // 包含FormData的是上传走的接口，此类型不可使用qs处理
  if (Object.prototype.toString.call(data).indexOf('FormData') >= 0) {
    datas = data;
  } else {
    datas = qs.stringify(data);
  }
  return service.post(url, datas, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}
// get
export function get(url, data = {}) {
  return service.get(
    url,
    { params: data },
    {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    },
  );
}
// put-----formData入参 (一般不用)
export function formPut(url, data = {}) {
  return service.put(url, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}
// put-----拼接url
export function urlPut(url, data = {}) {
  let link = globalProcessing.setObtainUrl(data);
  return service.put(url + link);
}
// put-----JSON入参
export function jsonPut(url, data = {}) {
  return service.put(url, data);
}
// delete-----JSON入参
export function jsonDelete(url, data = {}) {
  return service.delete(
    url,
    { data },
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  );
}
// delete-----formData入参
export function formDelete(url, data = {}) {
  return service.delete(
    url,
    { params: data },
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  );
}
// 请求拦截
service.interceptors.request.use(
  function (config) {
    // 请求拦截中模拟添加验证token
    config.headers.token = localStorage.getItem('token');
    return config;
  },
  function (err) {
    return Promise.reject(err);
  },
);
let that = this;
// 响应拦截
service.interceptors.response.use(
  function (response) {
    if (response.data.code && response.data.code == '403') {
      globalProcessing.reportErrors.error('Login invalid, please login again');
      localStorage.removeItem('ms_username');
      localStorage.removeItem('setRouter');
      localStorage.removeItem('setMenus');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('userRole');
      router.push('/login');
    }

    // console.log(toString.call(response.data), 'oooooooo');
    // if (response.status === 200) {
    //   globalProcessing.reportErrors.error('登陆失效，请重新登录');
    // }
    if (
      toString.call(response.data).indexOf('String') >= 0 &&
      (response.data.indexOf('<html lang="en">') >= 0 ||
        response.data.indexOf('<html lang="en">') <= 0)
    ) {
      globalProcessing.reportErrors.error('Login invalid, please login again');
      localStorage.removeItem('ms_username');
      localStorage.removeItem('setRouter');
      localStorage.removeItem('setMenus');
      localStorage.removeItem('token');
      localStorage.removeItem('id');
      localStorage.removeItem('userRole');
      router.push('/login');
    }
    // 此处判断登录是否失效,通过后台接口返回值的状态字段
    // if (response.status == 200) {
    //   window.location.href = '/';
    // }
    return response;
  },
  function (error) {
    console.log('测试', error);
    if (error.response) {
      let numberData = Number(error.response.status);
      if (numberData == 302) {
        // globalProcessing.reportErrors.error('登录超时，请重新登陆');
        globalProcessing.reportErrors.error(
          'Login invalid, please login again',
        );
        localStorage.removeItem('ms_username');
        localStorage.removeItem('setRouter');
        localStorage.removeItem('setMenus');
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('userRole');
        router.push('/login');
        return;
      }
      if (numberData == 403) {
        // globalProcessing.reportErrors.error('登录超时，请重新登陆');
        globalProcessing.reportErrors.error(
          'Login invalid, please login again',
        );
        localStorage.removeItem('ms_username');
        localStorage.removeItem('setRouter');
        localStorage.removeItem('setMenus');
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('userRole');
        router.push('/login');
        return;
      }
      if (numberData > 400 && numberData < 500) {
        globalProcessing.reportErrors.error('Request network exception');
      } else if (numberData > 500 && numberData < 600) {
        // globalProcessing.reportErrors.error('Server exception');
      } else {
        // globalProcessing.reportErrors.error('Network anomaly');
      }
    } else if (error.request) {
      // globalProcessing.reportErrors.error('Network anomaly');
    } else {
      // globalProcessing.reportErrors.error('Network anomaly');
    }
    return Promise.reject(error);
  },
);
